import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ColmecWorkOrder } from '../colmec-working-order-wrapper/colmec-working-order-wrapper.component';
import { ListItemRendererComponent, PimTemplateProperties } from 'gung-list';
import { DateUtilService } from 'gung-common';
import { ColumnSortSelectionService } from 'gung-standard';
import { ColmecWorkingOrderListConfigService } from '../../../services/colmec-working-order-list-config.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'colmec-working-order-table-view',
    templateUrl: './colmec-working-order-table-view.component.html',
    styleUrls: ['./colmec-working-order-table-view.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderTableViewComponent extends ListItemRendererComponent<ColmecWorkOrder[]> implements OnInit, OnDestroy {
  protected dateUtilService = inject(DateUtilService);
  protected columnSortSelectionService = inject(ColumnSortSelectionService);
  protected colmecWorkingOrderListConfigService = inject(ColmecWorkingOrderListConfigService);

  protected unsubscribe: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.colmecWorkingOrderListConfigService.dynamicColumns.pipe(takeUntil(this.unsubscribe)).subscribe(dc => this.dynamicColumns = dc);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  sortColumn(headerKey: PimTemplateProperties) {
    this.columnSortSelectionService.setSelectedColumnSort(headerKey);
    const ascSort = !headerKey.sort || headerKey.sort === 'asc' ? -1 : 1;
    this.clearSortColumns();
    headerKey.sort = ascSort === 1 ? 'asc' : 'desc';
    this.columnSortSelectionService.setSelectedColumnSort(headerKey);
  }

  clearSortColumns() {
    for (const c of this.dynamicColumns) {
      c.sort = undefined;
    }
    this.columnSortSelectionService.clearSelectedColumnSort();
  }
}
